import { message } from "antd";
import { handleApiError } from "./indexApi";
import Router from "../..";

const BASE_URL = process.env.REACT_APP_API_URL_PRO;

export const campaignApi = {
  // 공통
  getAllCampaigns: async (params = {}) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/get/list`,
        {
          params,
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }

      return res.data;
    } catch (err) {
      handleApiError(err, "캠페인 목록 조회에 실패했습니다.");
      return null;
    }
  },

  // 운송장 번호 및 배송 정보 조회
  getTrackingNumber: async (campaign_recruitment_id) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/get/tracking/status`,
        {
          params: { campaign_recruitment_id },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      return res.data;
    } catch (err) {
      handleApiError(err, "배송 정보 조회에 실패했습니다.");
      return false;
    }
  },

  // -----------------------------
  // 크리에이터 캠페인
  applyCampaign: async ({
    company_id,
    campaignId,
    attachment_url,
    message: applyMessage,
    requires_shipment,
    receiver_name,
    receiver_phone,
    receiver_country,
    receiver_street_address,
    receiver_address_line,
    receiver_city,
    receiver_state_province,
    receiver_postal_code,
    customs_clearance_number,
    delivery_message,
    sign,
    agency_id,
  }) => {
    try {
      const requestData = {
        company_id,
        campaign_id: campaignId,
        message: applyMessage,
        attachment_url,
        sign,
        agency_id,
      };

      // 배송이 필요한 경우에만 배송 정보 추가
      if (requires_shipment) {
        requestData.receiver_name = receiver_name;
        requestData.receiver_phone = receiver_phone;
        requestData.receiver_country = receiver_country;
        requestData.receiver_street_address = receiver_street_address;
        requestData.receiver_address_line = receiver_address_line;
        requestData.receiver_city = receiver_city;
        requestData.receiver_state_province = receiver_state_province;
        requestData.receiver_postal_code = receiver_postal_code;
        requestData.customs_clearance_number = customs_clearance_number;
        requestData.delivery_message = delivery_message;
      }

      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/apply`,
        requestData,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      if (data.error?.text) {
        message.error(data.error.text);
        return false;
      }
      if (data.result) {
        message.success("캠페인 신청이 완료되었습니다.");
        return true;
      }
      message.error("캠페인 신청에 실패했습니다.");
      return false;
    } catch (err) {
      handleApiError(
        err,
        "캠페인 신청에 실패했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  // 크리에이터 배송 정보 수정
  updateShipment: async (shipmentData) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/update/address`,
        shipmentData,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      if (data.result) {
        message.success("배송 정보가 수정되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "배송 정보 수정에 실패했습니다. 다시 시도해주세요.");
      return false;
    }
  },

  cancelCampaign: async ({ id }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/cancel`,
        { id },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("캠페인 신청이 취소되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(
        err,
        "캠페인 신청 취소에 실패했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  // 크리에이터 본인의 캠페인 리스트 조회
  getCampaignsByInfluencer: async ({ status, page = 1 } = {}) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/get/list/byinfluencer`,
        {
          params: { status, page },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );

      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }

      return res.data;
    } catch (err) {
      handleApiError(err, "나의 캠페인 목록 조회에 실패했습니다.");
      return null;
    }
  },

  //   캠페인 지원내역 상세 조회
  getAppliedCampaignsByInfluencer: async ({ campaign_id }) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/get/applied/byinfluencer`,
        {
          params: { campaign_id },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );

      if (res.data?.error) {
        return null;
      }

      return res.data;
    } catch (err) {
      handleApiError(err, "신청한 캠페인 목록 조회에 실패했습니다.");
      return null;
    }
  },

  // 크리에이터 미션 사전 제출 (유가)
  uploadPreMission: async ({ id, campaign_id, confirm_info, confirm_file }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/upload/confirm`,
        { id, campaign_id, confirm_info },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      if (Array.isArray(data.result) && Array.isArray(confirm_file)) {
        if (data.result.length !== confirm_file.length) return false;

        await Promise.all(
          data.result.map(({ uploadUrl }, index) =>
            fetch(uploadUrl, {
              method: "PUT",
              body: confirm_file[index],
            }).then((res) => {
              if (!res.ok) {
                throw new Error("파일 업로드에 실패했습니다.");
              }
            })
          )
        );

        // 파일 업로드 성공
        message.success("제출되었습니다.");
        return true;
      }

      if (data.result?.uploadUrl && confirm_file) {
        await fetch(data.result.uploadUrl, {
          method: "PUT",
          body: confirm_file,
        });

        // 파일 업로드 성공
        message.success("제출되었습니다.");
        return true;
      }

      if (data.error?.text) {
        message.error(data.error.text);
        return false;
      }

      message.error("제출에 실패했습니다.");
      return false;
    } catch (err) {
      handleApiError(err, "제출에 실패했습니다.");
      return false;
    }
  },

  // 크리에이터 미션 제출
  uploadMission: async ({ id, campaign_id, mission_url }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/upload/mission`,
        { id, campaign_id, mission_url },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("미션이 제출되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "미션 제출에 실패했습니다.");
      return false;
    }
  },

  // 크리에이터가 캠페인 초대 거절
  rejectCampaignInvitation: async (campaign_id) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/reject/invite`,
        { campaign_id, status: "rejected" },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("캠페인 초대가 거절되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "캠페인 초대 거절에 실패했습니다.");
      return false;
    }
  },

  //   -----------------------------
  //   브랜드 캠페인
  getCampaignsByBrand: async ({ status, page = 1 } = {}) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/get/list/bycompany`,
        {
          params: { status, page },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "브랜드 캠페인 목록 조회에 실패했습니다.");
      return null;
    }
  },

  getAppliedInfluencersByBrand: async ({ campaignId, status } = {}) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/get/applied/bycompany`,
        {
          params: {
            campaign_id: campaignId,
            status,
          },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "신청한 크리에이터 목록 조회에 실패했습니다.");
      return null;
    }
  },

  getInvitedInfluencersByBrand: async ({ campaignId, status } = {}) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/get/invited/bycompany`,
        {
          params: {
            campaign_id: campaignId,
            status,
          },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "초대한 크리에이터 목록 조회에 실패했습니다.");
      return null;
    }
  },

  createCampaign: async (campaignData) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/create`,
        campaignData,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("캠페인이 성공적으로 생성되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(
        err,
        "캠페인 생성에 실패했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  updateCampaign: async ({ id, ...campaignData }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/update`,
        { id, ...campaignData },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      if (data.result) {
        message.success("캠페인이 성공적으로 수정되었습니다.");
        return true;
      }
      message.error("캠페인 수정에 실패했습니다.");
      return false;
    } catch (err) {
      handleApiError(
        err,
        "캠페인 수정에 실패했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  updateCampaignStatus: async ({ campaignId, status }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/update/status`,
        { id: campaignId, status },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("캠페인 상태가 변경되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(
        err,
        "캠페인 상태 변경에 실패했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  deleteCampaign: async ({ campaignId }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/delete`,
        { id: campaignId },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("캠페인이 삭제되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(
        err,
        "캠페인 삭제에 실패했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  manageCampaignRequest: async ({ id, campaign_id, status }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/manage/request`,
        { id, campaign_id, status },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      const successMessageByStatus = {
        accepted: "수락되었습니다.",
        confirmed: "승인되었습니다.",
        rejected: "거절이 완료되었습니다.",
        cancelled: "취소가 완료되었습니다.",
        completed: "최종 완료되었습니다.",
      };

      if (data.result) {
        message.success(successMessageByStatus[status]);
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "거절되었습니다.");
      return false;
    }
  },

  // 캠페인 미션 피드백 알림
  sendFeedback: async ({ campaign_id, user_id, feedback }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/send/feedback`,
        { campaign_id, user_id, feedback },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("피드백이 전송되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "피드백 전송에 실패했습니다.");
      return false;
    }
  },

  // -----------------------------
  //   브랜드의 배송 부분
  // 브랜드가 지원한 크리에이터의 배송 정보 확인
  getInfluencerShipmentInfo: async (campaign_recruitment_id) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/get/shipment/address`,
        {
          params: { campaign_recruitment_id },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      return res.data;
    } catch (err) {
      handleApiError(err, "크리에이터의 배송 정보 확인에 실패했습니다.");
      return false;
    }
  },

  // 개별 운송장번호 등록
  updateTrackingNumber: async (shipmentData) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/update/shipment`,
        shipmentData,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      if (data.result) {
        message.success("운송장번호가 등록되었습니다.");
        return true;
      }

      // 에러 메시지 처리
      const errorMessage =
        data.error?.text || "운송장번호 등록에 실패했습니다.";
      message.error(errorMessage);
      return false;
    } catch (err) {
      handleApiError(err, "운송장번호 등록에 실패했습니다. 다시 시도해주세요.");
      return false;
    }
  },

  // 트래킹 번호 입력 안 한 모든 지원자 주소 불러오기
  getUnshippedAddress: async (campaign_id) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/get/unshipped`,
        {
          params: { campaign_id },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      return res.data;
    } catch (err) {
      handleApiError(
        err,
        "트래킹 번호 입력안한 모든 지원자 주소 불러오기에 실패했습니다."
      );
      return false;
    }
  },

  // 운송장번호 한 번에 등록 처리
  uploadShipmentExcel: async (excelData) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/bulk/update/shipment`,
        excelData,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("엑셀 파일로 업로드한 운송장이 모두 등록되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "운송장 등록에 실패했습니다.");
      return false;
    }
  },

  inviteInfluencerToCampaign: async ({
    campaign_id,
    message: inviteMessage,
    users,
  }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/invite`,
        { campaign_id, message: inviteMessage, users },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      if (data.error?.text) {
        message.error(data.error.text);
        return false;
      }

      if (data.result) {
        message.success("인플루언서 초대가 완료되었습니다.");
        return true;
      }
      return false;
    } catch (err) {
      handleApiError(err, "인플루언서 초대에 실패했습니다.");
      return false;
    }
  },

  // 에이전시
  getCampaignsByAgency: async ({ status, page = 1 } = {}) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/get/list/byagency`,
        {
          params: { status, page },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "에이전시 캠페인 목록 조회에 실패했습니다.");
      return null;
    }
  },

  // 에이전시가 신청한 인플루언서 목록 조회
  getAppliedInfluencersByAgency: async ({ campaignId, status } = {}) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/get/applied/byagency`,
        {
          params: {
            campaign_id: campaignId,
            status,
          },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "신청한 크리에이터 목록 조회에 실패했습니다.");
      return null;
    }
  },

  // 에이전시 캠페인 신청 (배열로 여러 명을 한 번에 신청)
  applyCampaignByAgency: async (applications) => {
    try {
      if (!Array.isArray(applications) || applications.length === 0) {
        message.error("신청할 크리에이터 정보가 없습니다.");
        return false;
      }

      const fileMap = {};
      const requestData = [];

      for (const app of applications) {
        const data = {
          campaign_id: app.campaign_id,
          company_id: app.company_id,
          user_id: app.user_id,
          message: app.message,
          sign: app.sign,
          attachment_info: app.attachment_info
            ? {
                original_filename: "",
                content_type: "",
              }
            : null,
        };

        if (app.attachment_file) {
          fileMap[app.user_id] = app.attachment_file;
        }

        // 배송이 필요한 경우에만 배송 정보 추가
        if (app.requires_shipment) {
          data.receiver_name = app.receiver_name;
          data.receiver_phone = app.receiver_phone;
          data.receiver_country = app.receiver_country;
          data.receiver_street_address = app.receiver_street_address;
          data.receiver_address_line = app.receiver_address_line;
          data.receiver_city = app.receiver_city;
          data.receiver_state_province = app.receiver_state_province;
          data.receiver_postal_code = app.receiver_postal_code;
          data.customs_clearance_number = app.customs_clearance_number;
          data.delivery_message = app.delivery_message;
        }

        requestData.push(data);
      }

      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/apply/byagency`,
        requestData,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      // presignedList가 배열인 경우 파일 업로드 처리
      if (Array.isArray(data.result) && data.result.length > 0) {
        try {
          for (const { user_id, uploadUrl } of data.result) {
            const file = fileMap[user_id];
            if (!file) continue;

            await fetch(uploadUrl, {
              method: "PUT",
              body: file,
            });
          }
          message.success("캠페인 신청이 완료되었습니다.");
          return true;
        } catch (uploadError) {
          message.error(
            "캠페인 신청은 완료되었지만 첨부 파일 업로드는 실패했습니다."
          );
          console.error("파일 업로드 실패:", uploadError);
          return false;
        }
      }

      // 파일이 없거나 개인 크리에이터인 경우
      if (
        data.result === "success" ||
        (Array.isArray(data.result) && data.result.length === 0)
      ) {
        message.success("캠페인 신청이 완료되었습니다.");
        return true;
      }

      message.error("캠페인 신청에 실패했습니다.");
      return false;
    } catch (err) {
      handleApiError(
        err,
        "캠페인 신청에 실패했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  // 에이전시의 캠페인 신청 취소
  cancelCampaignByAgency: async ({ campaign_id, user_ids }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/campaign/cancel/byagency`,
        { campaign_id, user_ids },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("캠페인 신청이 취소되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(
        err,
        "캠페인 신청 취소에 실패했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  // 인플루언서 측면, 캠페인 추천
  getRecommendedCampaigns: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/campaign/recommend`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "캠페인 추천 목록 조회에 실패했습니다.");
      return null;
    }
  },
};
